export default __webpack_public_path__ + "static/media/sura_logo.00a8acf7.png";